import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '@tcc-mono/shared/app-config';
import { BaseService } from '@tcc-mono/shared/data-access';

@Injectable({
  providedIn: 'root'
})
export class PdfService extends BaseService<any> {
  constructor(
    _http: HttpClient,
    @Inject(APP_CONFIG) appConfig: IAppConfig
  ) {
    super(_http, appConfig);
    this.path = 'api/pdf';
  }

  getPurchaseOrderPdf = (purchaseOrderId: number) => {
    return this._http.get(
      `${this.getUrl(`${this.path}/purchase_order/${purchaseOrderId}/order`)}`,
      {
        responseType: 'blob'
      }
    );
  };

  emailPurchaseOrderPdf = (purchaseOrderId: number) => {
    return this._http.get(
      `${this.getUrl(`${this.path}/purchase_order/${purchaseOrderId}/order?email=true`)}`
    );
  };

  getTransportGroupPdf = (transportGroupId: number, withWeights: boolean = false) => {
    return this._http.get(
      `${this.getUrl(
        `${this.path}/transport_group/${transportGroupId}/transport_list?with_weight=${withWeights}`
      )}`,
      {
        responseType: 'blob'
      }
    );
  };

  getBulkTransportGroupPdf = (transportGroup: number[], withWeights: boolean = false) => {
    return this._http.post(
      `${this.getUrl(`${this.path}/transport_group//transport_lists`)}`,
      {
        transport_groups: transportGroup,
        with_weight: withWeights
      },
      {
        responseType: 'blob'
      }
    );
  };

  getDailyReport = (date: string) => {
    return this._http.get(`${this.getUrl(`${this.path}/day/${date}`)}`, {
      responseType: 'blob'
    });
  };

  getVionDailyReport = (date: string) => {
    return this._http.get(`${this.getUrl(`${this.path}/vion_day/${date}`)}`, {
      responseType: 'blob'
    });
  };
}
